import { post, remove, get } from '../../shared/utils/fetch.util'

export const favorite = listingId =>
  post('/v1/app-users/me/favorites', { listingId })
export const unfavorite = listingId =>
  remove(`/v1/app-users/me/favorites/${listingId}`)
export const getFavorites = () => get('/v1/app-users/me/favorites/')
